import { createContext, Dispatch, SetStateAction } from "react";

export interface BeaconAccessContextType {
  hasBeaconAccess: boolean;
  setHasBeaconAccess: Dispatch<SetStateAction<boolean>>;
}

const BeaconAccessContext = createContext<BeaconAccessContextType>({
  hasBeaconAccess: false,
  setHasBeaconAccess: () => {},
});

export default BeaconAccessContext;
